import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';

import { Email, Language, ExitToApp } from '@mui/icons-material';
import {
  Alert,
  AlertTitle,
  Typography,
  Box,
  Link,
  Paper,
  Button,
} from '@mui/material';

import { authContext } from '@store/index';

import styles from './game-expired-alert.module.scss';

const GameExpiredAlert: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [, setAuthData] = useContext(authContext);

  const handleExit = async () => {
    console.log('Exit button clicked');
    console.log('Current location:', window.location.href);
    
    // Устанавливаем флаг выхода
    localStorage.setItem('forceLogout', 'true');
    
    try {
      // Сначала делаем запрос на сервер для выхода
      await axios.post('/logout');
      console.log('Server logout successful');
    } catch (error) {
      console.log('Server logout error:', error);
    }
    
    // Очищаем sessionStorage
    sessionStorage.clear();
    
    // Очищаем cookies
    document.cookie.split(";").forEach(function(c) { 
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
    });
    
    // Очищаем данные аутентификации
    setAuthData(undefined);
    
    // Очищаем axios состояние
    axios.defaults.headers.common = {};
    
    // Принудительно перезагружаем страницу для полного сброса состояния
    window.location.href = '/login';
    
    console.log('Exit completed');
  };

  return (
    <Paper elevation={3} className={styles.alertPaper}>
      <Alert severity="error" className={styles.mainAlert}>
        <AlertTitle className={styles.alertTitle}>
          {t('clientAll.gameExpiredTitle')}
        </AlertTitle>
        <Typography variant="body1" className={styles.alertMessage}>
          {t('clientAll.gameExpiredMessage')}
        </Typography>
      </Alert>
      
      <Box className={styles.contactSection}>
        <Typography variant="h6" className={styles.contactTitle}>
          {t('clientAll.needHelp')}
        </Typography>
        
        <Box className={styles.contactLinks}>
          <Link 
            href="mailto:hello@gameinvitation.com" 
            className={styles.contactLink}
            display="flex"
            alignItems="center"
            gap={1}
          >
            <Email fontSize="small" />
            hello@gameinvitation.com
          </Link>
          
          <Link 
            href="https://gameinvitation.com" 
            target="_blank"
            rel="noopener noreferrer"
            className={styles.contactLink}
            display="flex"
            alignItems="center"
            gap={1}
          >
            <Language fontSize="small" />
            gameinvitation.com
          </Link>
        </Box>
      </Box>

      <Box className={styles.exitSection}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleExit}
          startIcon={<ExitToApp />}
          className={styles.exitButton}
        >
          {t('clientAll.exitConstructor')}
        </Button>
      </Box>
    </Paper>
  );
};

export default GameExpiredAlert; 